import Login from '@/checkout-instore-legacy/components/Authentication/Login'
import LoginRedirectSuccess from '@/checkout-instore-legacy/components/Authentication/LoginRedirectSuccess'
import Logout from '@/checkout-instore-legacy/components/Authentication/Logout'
import CustomLink from '@/checkout-instore-legacy/components/CustomLink/CustomLink'
import DeviceEdit from '@/checkout-instore-legacy/components/Device/DeviceEdit'
import DeviceSummary from '@/checkout-instore-legacy/components/Device/DeviceSummary'
import IdentificationContainer from '@/checkout-instore-legacy/components/Identification/IdentificationContainer'
import ProfileContainer from '@/checkout-instore-legacy/customer/containers/ProfileContainer'
import RegisterContainer from '@/checkout-instore-legacy/customer/containers/RegisterContainer'
import DashboardWrapper from '@/checkout-instore-legacy/dashboard/components/DashboardWrapper'
import CancelOrderContainer from '@/checkout-instore-legacy/order/containers/CancelOrderContainer'
import LastOrdersContainer from '@/checkout-instore-legacy/order/containers/LastOrdersContainer'
import OrderPlacedContainer from '@/checkout-instore-legacy/order/containers/OrderPlacedContainer'
import OrdersContainer from '@/checkout-instore-legacy/orders/containers/OrdersContainer'
import ProductPageContainer from '@/checkout-instore-legacy/product/containers/ProductPageContainer'
import React, { useEffect, useState } from 'react'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { EnterHook, RouteComponent, RouterState } from 'react-router'
import ExchangeClientContainer from '@/checkout-instore-legacy/returnExchange/containers/ExchangeClientContainer'
import ExchangeSummaryContainer from '@/checkout-instore-legacy/returnExchange/containers/ExchangeSummaryContainer'
import OrderIdentifierContainer from '@/checkout-instore-legacy/returnExchange/containers/OrderIdentifierContainer'
import AddressContainer from '@/checkout-instore-legacy/shipping/containers/AddressContainer'
import PostalCodeContainer from '@/checkout-instore-legacy/shipping/containers/PostalCodeContainer'
import SlaSelectorContainer from '@/checkout-instore-legacy/shipping/containers/SlaSelectorContainer'
import PlacingOrderContainer from '@/checkout-instore-legacy/transaction/order/PlacingOrderContainer'
import { containers as cartContainers } from './cart'
import AppContainer from './components/AppContainer'
import PaymentContainer from './components/Payment/PaymentContainer'
import {
  hidePastOrderTopbar,
  noValidationRequired,
  withOrderFormContext,
  withVendorAuthorized,
  withVendorLoggedIn,
} from './routeHandler'
import { containers as searchContainers } from './search'
import { Switch, Route, useHistory, useLocation } from 'react-router-dom'
import startsWith from 'lodash/startsWith'
import { isRunningInsideInstoreCore } from '@/checkout-instore-legacy/utils/EnvUtils'

type RouteConfigLocation = {
  name: string
  pathname: string
}

export type RouteConfigProps = {
  name: string
  path: string
  titleId?: string
  title?: string
  context?: string
  customTopbar?: boolean
  topbarButton?: string
  topbarMode?: 'normal' | 'search' | 'modal'
  showSearch?: boolean
  showBarcode?: boolean
  hideTopbar?: boolean | ((location?: RouteConfigLocation) => boolean)
  backRouteFallback?: () => string
}

export type RouteConfig = RouteConfigProps & {
  component: RouteComponent
  onEnter: EnterHook
}

export type RoutesConfig = {
  login: RouteConfig[]
  sale: RouteConfig[]
  orderManagement: RouteConfig[]
  config: RouteConfig[]
  returnExchange: RouteConfig[]
  iframe: RouteConfig[]
  legacy: RouteConfig[]
}

export const routesConfigs: RoutesConfig = {
  login: [
    {
      path: 'vendor/login',
      name: 'vendor-login',
      context: 'Admin',
      component: Login,
      onEnter: noValidationRequired,
      hideTopbar: true,
    },
    {
      path: 'vendor/loginRedirectSuccess',
      name: 'vendor/loginRedirectSuccess',
      context: 'Admin',
      component: LoginRedirectSuccess,
      onEnter: noValidationRequired,
      hideTopbar: true,
    },
    {
      path: 'vendor/logout',
      name: 'vendor-logout',
      context: 'Admin',
      component: Logout,
      onEnter: noValidationRequired,
    },
  ],
  sale: [
    {
      name: 'identification',
      path: '/',
      component: IdentificationContainer,
      onEnter: withVendorAuthorized,
      showSearch: true,
      topbarButton: 'hamburger',
    },
    {
      path: 'cart-capture',
      name: 'cart-capture',
      component: IdentificationContainer,
      onEnter: withVendorAuthorized,
      topbarButton: 'hamburger',
    },
    {
      path: 'cart-change/:orderFormId(/:code)',
      name: 'cart-change',
      context: 'Internal',
      component: cartContainers.CartCopyContainer,
      onEnter: withVendorLoggedIn,
    },
    {
      path: 'cart-copy/:orderFormId',
      name: 'cart-copy',
      context: 'Internal',
      component: cartContainers.CartCopyContainer,
      onEnter: withVendorLoggedIn,
    },
    {
      path: 'client-profile',
      name: 'client-profile',
      context: 'Sale',
      component: ProfileContainer,
      onEnter: withOrderFormContext,
      titleId: 'clientProfileTopBar',
    },
    {
      path: 'client-register',
      name: 'client-register',
      context: 'Sale',
      component: RegisterContainer,
      onEnter: withOrderFormContext,
      titleId: 'editIdentifiedClient',
    },
    {
      path: 'search',
      name: 'search',
      context: 'Sale',
      component: searchContainers.SearchPageContainer,
      onEnter: withOrderFormContext,
      topbarMode: 'search',
      showSearch: true,
    },
    {
      path: 'cart',
      name: 'cart',
      context: 'Sale',
      component: cartContainers.CartContainer,
      onEnter: withOrderFormContext,
      topbarButton: 'back',
      showSearch: true,
    },
    {
      path: 'product/:productId',
      name: 'product-page',
      context: 'Sale',
      component: ProductPageContainer,
      onEnter: withOrderFormContext,
      titleId: 'productDetailLabel',
      topbarMode: 'search',
      topbarButton: 'hamburger',
    },
    {
      path: 'shipping-postalcode',
      name: 'shipping-postalcode',
      context: 'Sale',
      component: PostalCodeContainer,
      onEnter: withOrderFormContext,
      titleId: 'shippingPostalCodeTitle',
    },
    {
      path: 'shipping-address',
      name: 'shipping-address',
      context: 'Sale',
      component: AddressContainer,
      onEnter: withOrderFormContext,
      titleId: 'shippingAddressTitle',
    },
    {
      path: 'shipping-sla',
      name: 'shipping-sla',
      context: 'Sale',
      component: SlaSelectorContainer,
      onEnter: withOrderFormContext,
      titleId: 'shippingOptionsTitle',
    },
    {
      path: 'payment',
      name: 'payment',
      context: 'Sale',
      component: PaymentContainer,
      onEnter: withOrderFormContext,
    },
    {
      path: 'placeorder',
      name: 'placeorder',
      context: 'Sale',
      component: PlacingOrderContainer,
      onEnter: withOrderFormContext,
      hideTopbar: true,
    },
  ],
  orderManagement: [
    {
      path: 'orders',
      name: 'orders',
      context: 'Admin',
      component: OrdersContainer,
      onEnter: withOrderFormContext,
      titleId: 'ongoingSales',
    },
    {
      path: 'last-orders',
      name: 'last-orders',
      context: 'Admin',
      component: LastOrdersContainer,
      onEnter: withVendorAuthorized,
      topbarButton: 'hamburger',
    },
    {
      path: 'cancel-order',
      name: 'cancel-orders',
      context: 'Admin',
      component: CancelOrderContainer,
      onEnter: withVendorAuthorized,
      titleId: 'cancelOrderTitle',
    },
    {
      path: 'cancel-full-order',
      name: 'cancel-full-order',
      context: 'Admin',
      component: CancelOrderContainer,
      onEnter: withVendorAuthorized,
      titleId: 'cancelGroupOrderTitle',
    },
    {
      path: 'orderplaced',
      name: 'orderplaced',
      context: 'Sale',
      component: OrderPlacedContainer,
      onEnter: withVendorAuthorized,
      hideTopbar: hidePastOrderTopbar,
      titleId: 'lastOrders',
      backRouteFallback: () => '/last-orders',
    },
  ],
  config: [
    {
      path: 'device-summary',
      name: 'device-summary',
      component: DeviceSummary,
      onEnter: withVendorAuthorized,
    },
    {
      path: 'configure-device',
      name: 'configure-device',
      component: DeviceEdit,
      onEnter: withVendorAuthorized,
    },
  ],
  returnExchange: [
    {
      path: 'return-exchange',
      name: 'return-exchange',
      context: 'Internal',
      component: OrderIdentifierContainer,
      onEnter: withVendorAuthorized,
      topbarButton: 'hamburger',
    },
    {
      path: 'return-exchange/:orderId',
      name: 'return-exchange-order',
      context: 'Internal',
      component: ExchangeSummaryContainer,
      onEnter: withVendorAuthorized,
      topbarButton: 'hamburger',
    },
    {
      path: 'return-exchange/:orderId/client',
      name: 'return-exchange-order-client',
      context: 'Internal',
      component: ExchangeClientContainer,
      onEnter: withVendorAuthorized,
      topbarButton: 'hamburger',
    },
  ],
  iframe: [
    {
      path: 'custom-link',
      name: 'custom-link',
      context: 'Admin',
      component: CustomLink,
      onEnter: withVendorAuthorized,
    },
  ],
  legacy: [
    {
      path: 'store-performance',
      name: 'store-performance',
      context: 'Admin',
      component: DashboardWrapper,
      onEnter: withVendorAuthorized,
      topbarButton: 'hamburger',
    },
  ],
}

export const routesList = (() => {
  return [
    ...routesConfigs.login,
    ...routesConfigs.sale,
    ...routesConfigs.orderManagement,
    ...routesConfigs.config,
    ...routesConfigs.returnExchange,
    ...routesConfigs.iframe,
    ...routesConfigs.legacy,
  ].map((config) => ({
    ...config,
    hideTopbar: isRunningInsideInstoreCore() || config.hideTopbar,
  }))
})()

type ComponentWithGuardProps = {
  config: RouteConfig
}

const ComponentWithGuard = ({ config }: ComponentWithGuardProps) => {
  const history = useHistory()
  const location = useLocation()

  const [shouldRender, setShouldRender] = useState(false)

  useEffect(() => {
    const currentRoute = routesList.find(
      (route) =>
        (startsWith(route.path, '/') ? route.path : `/${route.path}`) ===
        location.pathname
    )

    const nextState = ({
      routes: [currentRoute],
    } as unknown) as RouterState

    config.onEnter(nextState, history.replace, () => {
      setShouldRender(true)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!shouldRender) return null

  const Component = config.component

  return <Component />
}

const toRoutes = (configs: RouteConfig[]) => {
  return configs.map((config) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { path, component, ...newConfig } = config

    if (config.path === '/') {
      return (
        <Route
          key={config.name}
          exact
          path={path}
          {...newConfig}
          render={() => <ComponentWithGuard config={config} />}
        />
      )
    }

    return (
      <Route
        key={config.name}
        exact
        path={`/${path}`}
        {...newConfig}
        render={() => <ComponentWithGuard config={config} />}
      />
    )
  })
}

export default (
  <AppContainer>
    <Switch>{toRoutes(routesList)}</Switch>
  </AppContainer>
)
